<template>
   <div ref="conclusionsContainer" id="section-6" class="site-section active-1">
      <div class="conclusions-inner">
         <div class="conclusion-mask">
            <ConclusionSection
                    v-for="article in articles"
                    :key="article.number"
                    :article="article"
            >
            </ConclusionSection>
            <div class="buttons">
               <p class="adobe-clean">ADOBE CAN HELP.<span>We build technology that helps media and entertainment brands embrace authenticity.</span>
               </p>
               <a class="adobe-clean-bold" href="http://www.adobe.com/industries/media-entertainment.html?promoid=9WGN456Y&mv=other" target="_blank">Learn More</a>
            </div>
         </div>
         <img class="adobe-logo-tab" src="../assets/images/logos/adobe-logo-tab.png" alt=""/>
      </div>
   </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {html} from './../consts'
    import content from './../content'
    import ConclusionSection from './ConclusionSection'

    export default {
        name: 'Conclusions',
        components: {
            ConclusionSection
        },
        data() {
            return {
                articles: content.articles,
                articleIndex: 1,
                mobileStyles: !this.$store.state.isPortrait,
                interval: null
            }
        },
        computed: {
            prevArticle() {
                return this.articleIndex === 1 ? this.articles.length : this.articleIndex - 1
            },
            activePosition() {
                return this.mobileStyles ? 'absolute' : 'relative';
            }
        },
        methods: {
            startLoop() {
                this.interval = setInterval(() => {
                    this.$el.removeAttribute('class');

                    this.articleIndex === this.articles.length ? this.articleIndex = 1 : this.articleIndex++;
                    this.$el.classList.add('active-' + this.articleIndex, 'out-' + this.prevArticle)
                }, 2500)
            },
            stopLoop() {
                clearInterval(this.interval);
            }
        },
        mounted() {
            this.$store.watch(
                (state) => {
                    return state.view;
                },
                (state) => {
                    if (state === 'conclusions') {
                        this.startLoop();
                    } else {
                        this.stopLoop();
                    }
                }
            );
        },
        beforeDestroy() {
            this.stopLoop();
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   #section-6 {
      position   : fixed;
      width      : 100vw;
      height     : 0;
      z-index    : 10;
      bottom     : 0;
      left       : 0;
      transition : transform .7s $default-bez;
      overflow-y : visible;

      .conclusions-inner {
         position        : fixed;
         top             : 0;
         left            : 0;
         width           : 100vw;
         height          : 100vh;
         display         : flex;
         justify-content : center;
         align-items     : center;
         transition      : transform 0.7s $default-bez;
         transform       : translateY(100%);
         z-index         : 10;

         .conclusions-active & {
            transform : translateY(0);
         }
      }

      .buttons {
         position       : absolute;
         bottom         : 0;
         left           : 0;
         display        : flex;
         align-items    : center;
         flex-direction : column;
         width          : 100%;

         .landscape-mode & {

            @include screen-xs-sm {
               position        : relative;
               width           : 40%;
               left            : 60%;
               padding         : 0 8vw 0 0;
               align-items     : center;
               flex-direction  : column;
               justify-content : center;
            }
         }

         @include screen-xs-sm {
            padding : 0 10vw;
         }

         p {
            font-size      : 17px;
            letter-spacing : .2em;
            color          : #fff;
            margin         : 0;
            text-align     : center;

            @include screen-xs-sm {
               font-size     : 14px;
               margin-bottom : 15px;
            }

            span {
               font-size      : 1.3rem;
               line-height    : 1.2;
               letter-spacing : 0;
               display        : block;
               margin-top     : 10px;

               @include screen-xs-sm {
                  margin-top : 15px;
               }
            }
         }

         a {
            margin-top    : 10px;
            background    : #1975E5;
            color         : #fff;
            padding       : 3px 23px;
            font-size     : 16px;
            border-radius : 15px;
            transition    : background-color 0.3s $default-bez;

            &:hover {
               text-decoration  : none;
               background-color : #005abe;
            }
         }
      }

      &.active-1 .conclusions-inner {
         background-color : #4F2099;
      }

      &.active-2 .conclusions-inner {
         background-color : #00C5A3;
      }

      &.active-3 .conclusions-inner {
         background-color : #C81000;
      }

      &.active-4 .conclusions-inner {
         background-color : #3839C3;
      }

      &.active-5 .conclusions-inner {
         background-color : #FE8B03;
      }

      .adobe-logo-tab {
         width    : 60px;
         position : absolute;
         bottom   : 0;
         right    : 35px;

         .portrait-mode & {

            @include screen-xs-sm {
               width : 50px;
               right : 20px;
            }
         }

         .landscape-mode & {

            @include screen-xs-sm {
               width     : 50px;
               right     : auto;
               left      : calc(80% - 4vw);
               transform : translateX(-50%);
            }
         }
      }
   }


</style>



// WEBPACK FOOTER //
// src/components/Conclusions.vue